import pako from 'pako';

import { withRouter } from '01_core/components/system/CustomRouter';
import ErrorCatchRoute from '01_core/components/system/ErrorCatchRoute';
import { CODE } from '01_core/constants/CodeConsts';
import { STRING_CONSTS } from '01_core/constants/stringConsts';
import AreaOrderingContainer from '12_masterdata/areaordering/AreaOrderingContainer';
import SiteOrderingContainer from '12_masterdata/siteordering/SiteOrderingContainer';
import ActivationReviewNaturalDisasterContainer from '31_bcm/document/ActivationReviewNaturalDisasterContainer';
import BcmKunrenContainer from '31_bcm/kunren/BcmKunrenContainer';
import KansaResultContainer from '32_kansa/kansaResult/KansaResultContainer';
import KansaAnswerContainer from '32_kansa/kansaanswer/KansaAnswerContainer';
import KansaReportContainer from '32_kansa/report/KansaReportContainer';
import React from 'react';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { Switch } from 'react-router-dom';

import LinearProgress from '@mui/material/LinearProgress';
import { styled } from '@mui/material/styles';
import withResponsive from '01_core/hooks/withResponsive';
import { styles } from './styles';

const stylesFromTheme = (theme) => (typeof styles === 'function' ? styles(theme) : styles);
const StyledMain = styled('main', {
  shouldForwardProp: (prop) => prop !== 'menuClosed',
})(({ theme, menuClosed }) => ({
  ...stylesFromTheme(theme).content,
  ...(menuClosed ? stylesFromTheme(theme).menuClose : {}),
}));
const StyledProgress = styled(LinearProgress)(({ theme }) => stylesFromTheme(theme).progress || {});

/**
 * 別ウィンドウ用コンポーネント
 */
export class NewWindow extends React.Component {
  render() {
    const { menuData, history } = this.props;

    // メニュー表示を行わない機能の場合、URL指定による直接遷移防止のため、呼び出し元のfunctionIdを設定し、
    // 利用可否の判定を行う（collerFunctionに呼び出し元のfunctionIdを設定）
    const componentDataNonMenuOrigin = {
      // ドキュメント管理（発動後レビュー）
      bcm_doc_activation_review: {
        component: ActivationReviewNaturalDisasterContainer,
        props: {
          selectSiteKindCd: CODE.SITE_KIND_CD.CODE_RH,
        },
        collerFunction: 'bcm_review',
      },
      // ドキュメント管理（自然災害）
      bcm_doc_natural_disaster: {
        component: ActivationReviewNaturalDisasterContainer,
        props: {
          selectSiteKindCd: CODE.SITE_KIND_CD.CODE_EQ,
        },
        collerFunction: 'bcm_bcp',
      },
      bcm_doc_kunren: {
        component: BcmKunrenContainer,
        collerFunction: 'bcm_kunren',
      },
      // 監査結果
      kansa_result: { component: KansaResultContainer },
      // 監査報告書
      kansa_report: { component: KansaReportContainer },
      // 監査回答
      kansa_answer: { component: KansaAnswerContainer },

      // 拠点表示順設定
      masterdata_site_ordering: { component: SiteOrderingContainer },
      // 地域表示順設定
      masterdata_area_ordering: { component: AreaOrderingContainer },
    };

    // CollerFunction 確認
    const includes = (collerFunction, fid) => {
      // 複数登録されている場合は登録内容に fid があるかをチェック
      // 単独登録されている場合は登録内容と fid が等しいかチェック
      if (Array.isArray(collerFunction)) {
        return collerFunction.includes(fid);
      } else {
        return collerFunction === fid;
      }
    };

    const componentDataNonMenu = {};
    const keyCheckNonMenu = (menuData) =>
      menuData.forEach((menu) => {
        Object.keys(componentDataNonMenuOrigin).forEach(function (key) {
          if (componentDataNonMenuOrigin[key].collerFunction) {
            if (includes(componentDataNonMenuOrigin[key].collerFunction, menu.fid) && menu.acd === '1') {
              componentDataNonMenu[key] = {
                ...componentDataNonMenuOrigin[key],
                pms: menu.pms,
              };
            }
          } else {
            if (
              !componentDataNonMenu[menu.fid] &&
              (menu.acd === '1' || menu.acd === '2') &&
              componentDataNonMenuOrigin[menu.fid]
            ) {
              componentDataNonMenu[menu.fid] = {
                ...componentDataNonMenuOrigin[menu.fid],
                pms: menu.pms,
              };
            }
          }
        });
        if (menu.childs) {
          keyCheckNonMenu(menu.childs);
        }
      });
    keyCheckNonMenu(menuData);

    //パラメータの取得と復号
    const deflatedBase64Params = new URLSearchParams(history.location.search).get('params');
    let params = null;
    if (deflatedBase64Params) {
      try {
        // URIデコード
        const decodeUriParams = window.decodeURIComponent(deflatedBase64Params);
        // Base64 → Uint8Array に変換
        const binaryString = atob(decodeUriParams);
        const uint8Array = Uint8Array.from(binaryString, char => char.charCodeAt(0));
        // pakoで解凍
        const inflatedParams = pako.inflate(uint8Array, { to: 'string' });
        // JSONに変換
        params = JSON.parse(inflatedParams);
      } catch (e) {
        console.error('inflate params error.', e);
      }
    }

    return (
      <div>
        <StyledMain>
          <Switch>
            {Object.keys(componentDataNonMenu).map((key, i) => {
              const Component = componentDataNonMenu[key].component;
              return (
                <ErrorCatchRoute
                  path={STRING_CONSTS.ROOT_PATH + key}
                  render={() => {
                    return (
                      <React.Suspense fallback={<StyledProgress color='secondary' />}>
                        <Component
                          {...componentDataNonMenu[key].props}
                          pms={componentDataNonMenu[key].pms}
                          fid={key}
                          isNewWindow={true}
                          {...params}
                        />
                      </React.Suspense>
                    );
                  }}
                  key={i}
                />
              );
            })}
          </Switch>
        </StyledMain>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  menuData: state.coreLoginInfo.menuData,
});

export default connect(mapStateToProps, null)(withResponsive(withRouter(injectIntl(NewWindow))));
